<div class="chart-cell-container">
  <div 
    *ngIf="showChart" 
    class="expand-icon" 
    (click)="expandChart()"
    title="View chart details">
    <i class="pi pi-external-link"></i>
  </div>
  
  <div *ngIf="showChart" style="display: block; width: 100%; height: 110px;">
    <canvas
      baseChart
      [type]="isMixedChart ? 'line' : chartType"
      [data]="chartData"
      [options]="chartOptions">
    </canvas>
  </div>
  
  <div class="no-data-message" *ngIf="!showChart">
    <span class="no-data-text">No chart data</span>
  </div>
</div>